import { Box, BoxProps } from '@mui/material';

const INACTIVE_TAG_COLOR = '#d32f2f';

/**
 * Renders the "(Inactive)" suffix shown next to deactivated brokers and
 * brokerages. The tag is always red; the entity name should be rendered
 * separately so it keeps its default (black) color.
 */
export const InactiveTag = ({ sx, ...props }: BoxProps) => (
  <Box component="span" sx={{ color: INACTIVE_TAG_COLOR, ...sx }} {...props}>
    (Inactive)
  </Box>
);
